module.exports = __webpack_public_path__ + "static/media/server.63795c11.svg";